import React from 'react';

import {useCurrentUser} from 'app/current-user/api';
import {TeamsSelectSingle} from 'app/teams/components/TeamsSelect';
import {useSweetTeamDetail} from 'app/teams/slice';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

const teamCt = getContentType('team');

type Props = {
  value?: string;
  placeholder?: string;
  onChange: (teamID: string) => Promise<unknown>;
  hideInNoTeamsOption?: boolean;
};

export type InNoTeamsOptionType = {
  name: string;
  url: string;
  id: number;
};

export const DashboardFilterbarTeams = ({
  value,
  placeholder,
  onChange,
  hideInNoTeamsOption,
}: Props) => {
  const {data: user} = useCurrentUser();
  const {team: selectedTeam} = useSweetTeamDetail(value ?? '');

  const currentUserId = user?.id;
  const isSuper = user?.is_super_manager || user?.is_super_teammate;

  const inNoTeamsOption: InNoTeamsOptionType = {
    name: gt('Not in a team'),
    url: 'in-no-teams',
    id: -1,
  };

  return (
    <TeamsSelectSingle
      params={
        !isSuper && currentUserId
          ? {
              user_id: currentUserId,
            }
          : undefined
      }
      lazyFetch={true}
      placeholder={placeholder || gt('Filter by team...')}
      selected={
        selectedTeam
          ? selectedTeam
          : value === inNoTeamsOption.id.toString()
          ? inNoTeamsOption
          : null
      }
      onChange={(team) => onChange(team != null ? team.id.toString() : '')}
      addFirstOption={hideInNoTeamsOption ? undefined : inNoTeamsOption}
      typeIcon={(team) => (team.id === -1 ? null : teamCt.icon)}
    />
  );
};
